var map = {
	"./0.png": "b331",
	"./1.png": "9043d",
	"./2.png": "0a4d",
	"./3.png": "2fb1",
	"./last-page.png": "9e04",
	"./next-page.png": "0c628",
	"./road.png": "e36e",
	"./title.png": "2063"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e456";